import ICurrency from "./ICurrency";
import CurrencyCode from "./CurrencyCodeEnum";
import CurrencySymbol from "./CurrencySymbolEnum";

export default class Currency implements ICurrency {
    constructor(public code: CurrencyCode = CurrencyCode.CZK, public symbol: CurrencySymbol = CurrencySymbol.CZK) {}
}
